import { memo } from 'react'

interface IPdfIconProps {
  size?: number
  className?: string
}

const PdfIcon: React.FC<IPdfIconProps> = memo(({ size = 16, className }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      className={className}
      viewBox="0 0 16 16"
      fill="none"
    >
      <rect x="2" y="5" width="12" height="8" fill="black" />
      <path
        d="M3.73353 8.53346H3.2002V7.4668H3.73353C3.87498 7.4668 4.01063 7.52299 4.11065 7.62301C4.21067 7.72303 4.26686 7.85868 4.26686 8.00013C4.26686 8.14158 4.21067 8.27723 4.11065 8.37725C4.01063 8.47727 3.87498 8.53346 3.73353 8.53346ZM7.46686 10.6668V7.4668H8.0002C8.14164 7.4668 8.2773 7.52299 8.37732 7.62301C8.47734 7.72303 8.53353 7.85868 8.53353 8.00013V10.1335C8.53353 10.2749 8.47734 10.4106 8.37732 10.5106C8.2773 10.6106 8.14164 10.6668 8.0002 10.6668H7.46686Z"
        fill="currentColor"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M1.06689 1.6C1.06689 1.17565 1.23547 0.768687 1.53552 0.468629C1.83558 0.168571 2.24255 0 2.66689 0L11.421 0L14.9336 3.51253V14.4C14.9336 14.8243 14.765 15.2313 14.4649 15.5314C14.1649 15.8314 13.7579 16 13.3336 16H2.66689C2.24255 16 1.83558 15.8314 1.53552 15.5314C1.23547 15.2313 1.06689 14.8243 1.06689 14.4V1.6ZM3.73356 6.4H2.13356V11.7333H3.20023V9.6H3.73356C4.15791 9.6 4.56487 9.43143 4.86493 9.13137C5.16499 8.83131 5.33356 8.42435 5.33356 8C5.33356 7.57565 5.16499 7.16869 4.86493 6.86863C4.56487 6.56857 4.15791 6.4 3.73356 6.4ZM8.00023 6.4H6.40023V11.7333H8.00023C8.42457 11.7333 8.83154 11.5648 9.1316 11.2647C9.43166 10.9646 9.60023 10.5577 9.60023 10.1333V8C9.60023 7.57565 9.43166 7.16869 9.1316 6.86863C8.83154 6.56857 8.42457 6.4 8.00023 6.4ZM10.6669 11.7333V6.4H13.8669V7.46667H11.7336V8.53333H12.8002V9.6H11.7336V11.7333H10.6669Z"
        fill="currentColor"
      />
    </svg>
  )
})

PdfIcon.displayName = 'PdfIcon'

export { PdfIcon }
